import React from 'react';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import Warning from '@mui/icons-material/Warning';

const BehaviorHeader = ({ videoId, selectedDataPoint, behavior }) => (
  <>
    {videoId && selectedDataPoint && (
      <Alert
        severity='warning'
        icon={<Warning sx={{ color: 'white' }} />}
        sx={{
          mt: 2,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: '#9291ef',
          color: 'white',
          fontSize: '0.9rem',
          padding: '12px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 3,
        }}
      >
        <Box>
          <AlertTitle
            sx={{
              fontWeight: 'bold',
              color: 'white',
              display: 'inline-block',
            }}
          >
            Warning
          </AlertTitle>
          <Typography variant='body2' sx={{ color: 'white' }}>
            A data entry for this QuickTrack already exists for this video.
            You can only edit the existing entry.
          </Typography>
        </Box>
      </Alert>
    )}
   
  </>
);

export default BehaviorHeader; 